export default {
    "home":"Home",
    "about":"About",
    "aboutUs":"About Us",
    "p1":"MIDONKEY focus on high performance electric bicycle and electric bicycle parts manufacturing for over 6 years. We are committed to providing customers with total solutions for durable and practical electric bike, covering from electric bicycle kits to the whole packed electric bikes.",
    "p2":"According to the needs of different country markets, we research and develop new practical ebike models, always ready to provide global customers with highly competitive products and services.",
    "p3":"Due to our superior quality and excellent services, we are therefore become an important business partner with Fortune 500.",
    "dongguan":"Dongguan Factory",
    "hailong":"Hailong Battery",

    "conpanyInfo":"COMPANY INFO",
    "midonkey":"About MIDONKEY",
    "branches":"Subsidiaries & Branches",
    "factoryTour":"Factory Tour",
    "certificates":"Certificates",
    "release":"News Release",
    "careers":"Careers",
    "userFeedback":"User Feedback"
  };